import script from "./SingleProductTableBulkOperations.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleProductTableBulkOperations.vue?vue&type=script&setup=true&lang=js"

import "./SingleProductTableBulkOperations.vue?vue&type=style&index=0&id=151d6c04&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151d6c04"]])

export default __exports__